import { render, staticRenderFns } from "./VTaxClassificationSelector.vue?vue&type=template&id=48d967ca"
import script from "./VTaxClassificationSelector.vue?vue&type=script&lang=ts"
export * from "./VTaxClassificationSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports